import defaultColors from '../utils/colors';
import type { Colors } from '../types';

const baseColors: Colors.Object & Colors.BaseVariantsType = {
  ...defaultColors,
  accent: defaultColors.indigo[60],
  background: defaultColors.white,
  blueSteel: defaultColors.coolGrey[100],
  disabled: defaultColors.coolGrey[10],
  disabledBorder: defaultColors.coolGrey[30],
  grey: defaultColors.coolGrey[10],
  heading: defaultColors.coolGrey[100],
  interactive: defaultColors.coolGrey[100],
  label: defaultColors.coolGrey[100],
  lightGrey: defaultColors.coolGrey[30],
  muted: defaultColors.indigo[60],
  paragraph: defaultColors.coolGrey[100],
  subheading: defaultColors.coolGrey[90],
  text: defaultColors.coolGrey[100],
};

const baseThemeSpecificColors: Colors.ThemeVariantsType = {
  hyperlink: defaultColors.coolGrey[90],
  primary: defaultColors.coolGrey[90],
  primaryAccent: defaultColors.coolGrey[90],
  primarySecondaryAccent: defaultColors.coolGrey[100],
  primaryTertiaryAccent: defaultColors.coolGrey[100],
  primaryText: defaultColors.coolGrey[90],
  secondary: defaultColors.coolGrey[100],
  secondaryText: defaultColors.coolGrey[100],
  tertiary: defaultColors.coolGrey[100],
  tertiaryText: defaultColors.coolGrey[100],
};

const chart = {
  ...baseColors,
  hyperlink: defaultColors.orange[70],
  primary: defaultColors.orange[45],
  primaryAccent: defaultColors.orange[25],
  primarySecondaryAccent: defaultColors.orange[10],
  primaryTertiaryAccent: defaultColors.orange[5],
  primaryText: defaultColors.coolGrey[90],
  secondary: defaultColors.indigo[60],
  secondaryText: defaultColors.coolGrey[100],
  tertiary: defaultColors.teal[20],
  tertiaryText: defaultColors.teal[20],
};

const co = {
  ...baseColors,
  hyperlink: defaultColors.blue[70],
  primary: defaultColors.blue[60],
  primaryAccent: defaultColors.coolGrey[80],
  primarySecondaryAccent: defaultColors.coolGrey[30],
  primaryTertiaryAccent: defaultColors.coolGrey[10],
  primaryText: defaultColors.blue[60],
  secondary: defaultColors.coolGrey[100],
  secondaryText: defaultColors.coolGrey[100],
  tertiary: defaultColors.yellow[20],
  tertiaryText: defaultColors.yellow[20],
};

const edu = {
  ...baseColors,
  hyperlink: defaultColors.indigo[80],
  primary: defaultColors.indigo[70],
  primaryAccent: defaultColors.coolGrey[80],
  primarySecondaryAccent: defaultColors.coolGrey[30],
  primaryTertiaryAccent: defaultColors.coolGrey[10],
  primaryText: defaultColors.indigo[70],
  secondary: defaultColors.coolGrey[90],
  secondaryText: defaultColors.coolGrey[90],
  tertiary: defaultColors.yellow[20],
  tertiaryText: defaultColors.yellow[20],
};

const scale = {
  ...baseColors,
  hyperlink: defaultColors.indigo[70],
  primary: defaultColors.indigo[60],
  primaryAccent: defaultColors.indigo[100],
  primarySecondaryAccent: defaultColors.indigo[30],
  primaryTertiaryAccent: defaultColors.indigo[5],
  primaryText: defaultColors.indigo[60],
  secondary: defaultColors.yellow[20],
  secondaryText: defaultColors.yellow[20],
  tertiary: defaultColors.earth[10],
  tertiaryText: defaultColors.earth[10],
};

const spark = {
  ...baseColors,
  hyperlink: defaultColors.red[70],
  primary: defaultColors.red[50],
  primaryAccent: defaultColors.red[80],
  primarySecondaryAccent: defaultColors.red[20],
  primaryTertiaryAccent: defaultColors.red[5],
  primaryText: defaultColors.red[50],
  secondary: defaultColors.indigo[80],
  secondaryText: defaultColors.indigo[80],
  tertiary: defaultColors.yellow[20],
  tertiaryText: defaultColors.yellow[20],
};

const colors: Colors.Base = {
  ...baseColors,
  ...baseThemeSpecificColors,
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    scale,
    spark,
  },
};

export default colors;
